import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManageCardOnFileComponent } from './manage-card-on-file/manage-card-on-file.component';
import { AddNewCardComponent } from './add-new-card/add-new-card.component';
import { AutopaySettingComponent } from './autopay-setting/autopay-setting.component';
import {ManagePaymentMethodsComponent} from './manage-payment-methods/manage-card-on-file.component';
const routes: Routes = [
			{ path: 'manage_payment_methods', component: ManagePaymentMethodsComponent},
			{ path: 'manage_payment_methods/new_card', component: AddNewCardComponent},
			{ path: 'manage_cards/autopay_settings', component: AutopaySettingComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManageCardsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/payment/manage-cards/manage-cards-routing.module.ts